import { withAuthenticationRequired } from '@tom-ui/utils'
import { Box } from '@mui/material'
import { usePlanningStore } from '@planning/AppProvider'
import { useMinimalsTheme } from '@tom-ui/ui'
import { FC, ReactNode, useMemo } from 'react'
import { YardClerkHeader } from './Components/molecules/YardClerkHeader'
import { YardClerkJourneyList } from './Components/organisms/YardClerkJourneyList'
import { YardClerkUpdatePosition } from './Components/organisms/YardClerkUpdatePosition'
import { YardClerkViewStore } from './Stores/YardClerkViewStore'
import { YardSelectorProps } from './models/yard-selector.model'

type Props = {
  yardSelector?: (props: YardSelectorProps) => ReactNode
  handleUpdatePosition?: (journeyId: number) => Promise<void>
}

const YardClerkPage: FC<Props> = withAuthenticationRequired(
  ({ yardSelector, handleUpdatePosition }) => {
    const theme = useMinimalsTheme()
    const { appViewStore } = usePlanningStore()

    const yardClerkViewStore = useMemo(() => {
      const viewStore = new YardClerkViewStore(appViewStore)
      viewStore.handleUpdatePosition = handleUpdatePosition

      return viewStore
    }, [appViewStore, handleUpdatePosition])

    return (
      <Box
        sx={{
          height: '100vh',
          bgcolor: theme.palette.grey[200],
        }}
      >
        <YardClerkHeader />
        <YardClerkJourneyList yardClerkViewStore={yardClerkViewStore} />
        <YardClerkUpdatePosition
          yardClerkViewStore={yardClerkViewStore}
          yardSelector={yardSelector}
        />
      </Box>
    )
  },
)

export default YardClerkPage
